<header class="layout-grid">
    <mat-toolbar fixedInViewPort>
        <button
            type="button"
            aria-label="Toggle menu navigation"
            mat-icon-button
            [disabled]="preview"
            (click)="onClick_toggleMobileMenu()"
            *ngIf="!appService?.isWide && !(inboundRedirectService?.isInboundRedirectUIContext)">
            <mat-icon aria-label="Menu navigation toggle icon" svgIcon="menu"></mat-icon>
        </button>

        <div class="header__logo" *ngIf="!(inboundRedirectService?.isInboundRedirectUIContext)">
            <a *ngIf="!preview && !editMode" routerLink="/">
                <img [src]="logoSource" [alt]="siteTitle + ' Home'">
            </a>
            <img *ngIf="preview || editMode" 
                 [src]="logoSource" 
                 [alt]="siteTitle + ' Home'"
                 [class.editable-logo]="editMode"
                 [tabindex]="editMode ? 0 : -1"
                 (click)="onLogoClick()"
                 (keydown.enter)="onLogoClick()"
                 (keydown.space)="onLogoClick()"
                 [attr.role]="editMode ? 'button' : null"
                 [matTooltip]="editMode ? 'Click to upload new logo (PNG, at least 56 pixels tall)' : ''">
        </div>
        <div class="header__logo" *ngIf="inboundRedirectService?.isInboundRedirectUIContext">
            <img [src]="logoSource" [alt]="siteTitle + ' Logo'">
        </div>

        <nav aria-label="Primary" *ngIf="!appService?.isWide && inboundRedirectService?.isInboundRedirectUIContext" class="navigation">
            <!-- We need to display a mat-flat-button on the receipt page -->
            <button mat-flat-button color="accent"
                    *ngIf="isCheckoutSuccessPage"
                    (click)="onClick_cancelOrCompletePayment()"
                    class="navigation-link">
                <span>{{returnToSenderLabel}}</span>
            </button>
            <!-- and a mat-button on all other pages (currently limited to the checkout page, but this list will expand) -->
            <button mat-button
                    *ngIf="!isCheckoutSuccessPage"
                    (click)="onClick_cancelOrCompletePayment()"
                    class="navigation-link">
                <span>{{returnToSenderLabel}}</span>
            </button>
        </nav>

        <nav aria-label="Primary" *ngIf="appService?.isWide" class="navigation">
            <!-- We need to display a mat-flat-button on the receipt page -->
            <button mat-flat-button color="accent"
                    *ngIf="inboundRedirectService?.isInboundRedirectUIContext && isCheckoutSuccessPage"
                    (click)="onClick_cancelOrCompletePayment()"
                    class="navigation-link">
                <span>{{returnToSenderLabel}}</span>
            </button>

            <!-- and a mat-button on all other pages (currently limited to the checkout page, but this list will expand) -->
            <button mat-button
                    *ngIf="inboundRedirectService?.isInboundRedirectUIContext && !isCheckoutSuccessPage"
                    (click)="onClick_cancelOrCompletePayment()"
                    class="navigation-link">
                <span>{{returnToSenderLabel}}</span>
            </button>

            <a *ngIf="!(inboundRedirectService?.isInboundRedirectUIContext)" mat-button
                [routerLink]="preview ? null : '/'"
                routerLinkActive="navigation-link--active"
                [routerLinkActiveOptions]="{ exact: true }"
                class="navigation-link"
                [ngClass]="{'preview navigation-link--active' : preview}"
                [attr.aria-current]="appService?.ariaCurrent('/', true)">
                <mat-icon svgIcon="home" class="teller-online-icon"></mat-icon>
                <span>Home</span>
            </a>

            <a *ngIf="authenticationEnabled && !(authService?.isSignedIn) && !(inboundRedirectService?.isInboundRedirectUIContext)" mat-button
                [routerLink]="preview ? null : '/sign-in'"
                routerLinkActive="navigation-link--active"
                class="navigation-link"
                [attr.aria-current]="appService?.ariaCurrent('/sign-in')">
                <mat-icon svgIcon="login" class="teller-online-icon"></mat-icon>
                <span>Sign In</span>
            </a>

            <a *ngIf="authenticationEnabled && !(authService?.isSignedIn) && !(inboundRedirectService?.isInboundRedirectUIContext)" mat-flat-button color="accent"
                [routerLink]="preview ? null : '/sign-up'"
                routerLinkActive="navigation-link--active"
                class="navigation-link"
                [attr.aria-current]="appService?.ariaCurrent('/sign-up')">
                <mat-icon svgIcon="sign-up" class="teller-online-icon"></mat-icon>
                <span>Sign Up</span>
            </a>

            <ng-container *ngIf="authenticationEnabled && authService?.isSignedIn && !(inboundRedirectService?.isInboundRedirectUIContext)">
                <button mat-button 
                        [matMenuTriggerFor]="profilenav" 
                        class="navigation-group" 
                        [ngClass]="{'navigation-group--active': appService?.currentPage('/profile')}"
                        [attr.aria-label]="(userService?.currentUser?.name || 'User') + ': User profile'">
                    <mat-icon svgIcon="user" class="teller-online-icon"></mat-icon>
                    {{userService?.currentUser?.name || 'User'}}
                    <mat-icon>expand_more</mat-icon>
                </button>
                
                <mat-menu #profilenav="matMenu" 
                          class="navigation">
                    <a mat-menu-item
                        routerLink="/profile/personal-info"
                        routerLinkActive="navigation-link--active"
                        class="navigation-link"
                        [attr.aria-current]="appService?.ariaCurrent('/profile/personal-info')"
                        aria-label="Personal Info link">Personal Info</a>
                    <a mat-menu-item
                        routerLink="/profile/notification-settings"
                        routerLinkActive="navigation-link--active"
                        class="navigation-link"
                        [attr.aria-current]="appService?.ariaCurrent('/profile/notification-settings')"
                        aria-label="Notification Settings link">Notification Settings</a>
                    <a mat-menu-item
                        routerLink="/profile/change-password"
                        routerLinkActive="navigation-link--active"
                        class="navigation-link"
                        [attr.aria-current]="appService?.ariaCurrent('/profile/change-password')"
                        aria-label="Change Password link">Change Password</a>
                    <a mat-menu-item
                        *ngIf="canSavePaymentMethod"
                        routerLink="/profile/payment-methods"
                        routerLinkActive="navigation-link--active"
                        class="navigation-link"
                        [attr.aria-current]="appService?.ariaCurrent('/profile/payment-methods')"
                        aria-label="Payment Methods link">Payment Methods</a>
                    <a mat-menu-item
                        routerLink="/profile/payment-history"
                        routerLinkActive="navigation-link--active"
                        class="navigation-link"
                        [attr.aria-current]="appService?.ariaCurrent('/profile/payment-history')"
                        aria-label="Payments link">{{siteMetadataService.scheduledPaymentsEnabled ? 'Payments' : 'Payment History'}}</a>
                    <a mat-menu-item
                        *ngIf="siteMetadataService?.scheduledPaymentsEnabled"
                        routerLink="/profile/schedules"
                        routerLinkActive="navigation-link--active"
                        class="navigation-link"
                        [attr.aria-current]="appService?.ariaCurrent('/profile/schedules')"
                        aria-label="Schedules link">Schedules</a>
                    <button mat-menu-item 
                            [disabled]="preview"
                            (click)="onClick_signOut()" 
                            class="navigation-link"
                            aria-label="Sign out button">Sign Out</button>
                </mat-menu>
            </ng-container>
        </nav>

        <button [disabled]="preview"
                (click)="onClick_toggleHelp()"
                *ngIf="!(inboundRedirectService?.isInboundRedirectUIContext)"
                mat-icon-button class="help-button"
                aria-controls="help-sidebar"
                [attr.aria-expanded]="helpOpened"
                aria-label="Help"
                matTooltip="Help">
            <mat-icon svgIcon="help"></mat-icon>
        </button>
    </mat-toolbar>
</header>